import React from 'react';
import {
  UsersIcon,
  UserPlusIcon,
  WrenchScrewdriverIcon,
  RocketLaunchIcon,
  FolderArrowDownIcon,
  BellIcon,
  EnvelopeIcon,
  Cog6ToothIcon,
  ClipboardDocumentCheckIcon,
} from '@heroicons/react/24/outline';

export interface NavItem {
  label: string;
  to: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  iconUrl?: string;
  badge?: string | number;
  exact?: boolean;
  external?: boolean;
  adminOnly?: boolean; // Only visible to admins, not VAs
  children?: NavItem[]; // Nested items for dropdown menus
}

const allAdminNavigation: NavItem[] = [
  {
    label: 'Add Recruit',
    to: '/admin/recruits/new',
    icon: UserPlusIcon,
  },
  {
    label: 'Pipeline',
    to: '/admin/prospects',
    icon: UsersIcon,
  },
  {
    label: 'Onboarding',
    to: '/admin/loan-officers',
    icon: UsersIcon,
  },
  {
    label: 'Hands On',
    to: '/admin/hands-on',
    icon: ClipboardDocumentCheckIcon,
  },
  {
    label: 'Settings',
    to: '/admin/settings',
    icon: Cog6ToothIcon,
    adminOnly: true,
    children: [
      {
        label: 'Step Management',
        to: '/admin/workflows',
        icon: WrenchScrewdriverIcon,
      },
      {
        label: 'Notifications',
        to: '/admin/notification-settings',
        icon: BellIcon,
      },
      {
        label: 'Email Templates',
        to: '/admin/email-templates',
        icon: EnvelopeIcon,
      },
    ],
  },
];

// Returns navigation filtered by role
export const getAdminNavigation = (isVA: boolean): NavItem[] => {
  if (isVA) {
    return allAdminNavigation.filter((item) => !item.adminOnly);
  }
  return allAdminNavigation;
};

// Default admin navigation (for backwards compatibility)
export const adminNavigation: NavItem[] = allAdminNavigation;

export const getLoNavigation = (locationId?: string): NavItem[] => [
  {
    label: 'Onboarding Portal',
    to: '/onboarding',
    icon: RocketLaunchIcon,
    exact: true,
  },
  {
    label: 'Hands On',
    to: '/hands-on',
    icon: ClipboardDocumentCheckIcon,
  },
  {
    label: 'My Resources',
    to: '/onboarding/resources',
    icon: FolderArrowDownIcon,
  },
  {
    label: 'L-3 CRM',
    to: locationId ? `https://app.luminlending.com/v2/location/${locationId}/dashboard` : '#',
    iconUrl: 'https://storage.googleapis.com/msgsndr/iFlKw9I7G6zRLSgzz6fG/media/68aa803644664f616ef7127c.png',
    external: true,
  },
  {
    label: 'Arive',
    to: 'https://luminlending.myarive.com/',
    iconUrl: '/arive-logo.png',
    external: true,
  },
];

// Backwards compatibility
export const loNavigation: NavItem[] = getLoNavigation();
